import React, { useState, useCallback, memo } from 'react';
import { Dropdown } from '../../../../components/Dropdown';
import { APIKeyService } from '../../../../services/APIKeyService';
import { APIKeyStatus, APIKey } from '../../../../entities/APIKey';
import { SpanTooltip } from '../../../../components/SpanTooltip';
import { IconButton } from '../../../../components/IconButton';
import { EditAPIKeyNameModal } from '../APIKeyModal/EditAPIKeyNameModal';
import { APIKeyEnableDisableModal } from './APIKeyEnableDisableModal';
import { buildMenuAction } from './MenuActionItem';

interface PropTypes {
  apiKey: APIKey;
}

const RowActionsDropdown: React.FC<PropTypes> = ({ apiKey }) => {
  const [isEnableDisableModalOpen, setEnableDisableModalOpen] = useState(false);
  const [editAPIKey, setEditAPIKey] = useState(false);
  const isRevoked = apiKey.status === APIKeyStatus.Revoked;

  const handleEditKey = useCallback(() => setEditAPIKey(true), []);
  const handleRevokeAction = useCallback(
    () => setEnableDisableModalOpen(true),
    [],
  );

  const handleAPIKeyEnableDisableConfirm = useCallback(async () => {
    try {
      const newStatus = isRevoked ? APIKeyStatus.Active : APIKeyStatus.Revoked;
      await APIKeyService.update(apiKey.id, apiKey.name, newStatus);
      window.location.reload();
    } catch (error) {
      console.error('Failed to update API key status:', error);
    }
  }, [apiKey.id, apiKey.name, isRevoked]);

  const handleUpdateAPIKey = useCallback(
    async (name: string) => {
      try {
        await APIKeyService.update(apiKey.id, name, apiKey.status);
        window.location.reload();
      } catch (error) {
        console.error('Failed to update API key name:', error);
      }
    },
    [apiKey.id, apiKey.status],
  );

  const menuActions = [
    buildMenuAction(handleEditKey, 'Edit Key Name', 'bi-pencil'),
    buildMenuAction(handleRevokeAction, 'Revoke', 'bi-x'),
  ];

  return (
    <>
      {!isRevoked ? (
        <Dropdown
          buttonIcon={{
            name: 'bi-three-dots',
            className: 'fs-4 text-info',
          }}
          menuPlacementClass='dropdown-menu-end'
          menuActions={menuActions}
        />
      ) : (
        <SpanTooltip
          text={
            <IconButton
              iconName='bi-arrow-repeat'
              color='borderless'
              size='sm'
              onClick={handleRevokeAction}
            />
          }
          tooltipText='Re-enable'
          trigger='hover'
        />
      )}

      {isEnableDisableModalOpen && (
        <APIKeyEnableDisableModal
          isOpen={isEnableDisableModalOpen}
          onConfirm={handleAPIKeyEnableDisableConfirm}
          setIsOpen={setEnableDisableModalOpen}
          apiKeyStatus={apiKey.status}
        />
      )}

      {editAPIKey && (
        <EditAPIKeyNameModal
          onSubmit={handleUpdateAPIKey}
          onClose={() => setEditAPIKey(false)}
          name={apiKey.name}
          token={apiKey.token}
        />
      )}
    </>
  );
};

export default memo(RowActionsDropdown);
